<div class="container mt-5 text-center footer" >
    <h5>Open for commissions, trades or collabs </h5>
    <img src="../assets/imgs/gif1.gif" alt="" style="width:100px; height: 100px;" class="my-4">
    <br>
    <a href="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=lorenzoroncarati@gmail.com&subject=MISSED%20CALL%20EZTRADER&body=Hello%2C%0A%0A" target="_blank" style="text-decoration:none;"><button type="button" class="btn btn-light">CONTACT ME</button></a>

    


    <br><br><br>
</div>